import React from 'react';
import Release_Hold_Salary from './Release_Hold_Salary';
import '../../../CommonCSS/SocietyCSS.css'

const Release_Hold_SalaryApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Release On-Hold Salary</h5>
          </div>  
        </div>
        <Release_Hold_Salary/>
      </div>
    </div >
  );
};

export default Release_Hold_SalaryApp;
